import { render, staticRenderFns } from "./pay_page.vue?vue&type=template&id=1cd086fc&scoped=true&"
import script from "./pay_page.vue?vue&type=script&lang=js&"
export * from "./pay_page.vue?vue&type=script&lang=js&"
import style0 from "./pay_page.vue?vue&type=style&index=0&id=1cd086fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd086fc",
  null
  
)

export default component.exports